if (!customElements.get('fostr-hero-banner-scroll')) {
  customElements.define('fostr-hero-banner-scroll', class FostrHeroScroll extends HTMLElement {
  
    constructor() {
      super();
  
      this.targetMain = document.querySelectorAll('.banner--scroll .banner_main.banner__content .banner__box');
      this.targetContent = document.querySelectorAll('.banner--scroll .banner_sub.banner__content .banner__box');
      this.targetSupport = document.querySelectorAll('.banner + .banner_additional.banner__content .banner__box');
  
      this.observerOptionsMain = { rootMargin: "-80px 0px", threshold: [1] }
      this.observerOptionsContent = { rootMargin: "-180px 0px -30px 0px", threshold: [1] }
      this.observerOptionsSupport = { rootMargin: "-180px 0px -50px 0px", threshold: [1] }
  
      if(screen.availWidth <= 749){
        this.observerOptionsMain = { rootMargin: "-60px 0px", threshold: [1] }
        this.observerOptionsContent = { rootMargin: "-60px 0px 0px 0px", threshold: [1] }
        this.observerOptionsSupport = { rootMargin: "-60px 0px -30px 0px", threshold: [1] }
      }
  
      this.observerMain = new IntersectionObserver(this.observerCallbackMain, this.observerOptionsMain);
      this.observerContent = new IntersectionObserver(this.observerCallbackContent, this.observerOptionsContent);
      this.observerSupport = new IntersectionObserver(this.observerCallbackSupport, this.observerOptionsSupport);
  
      this.targetMain.forEach((i) => {
        if (i) {
          this.observerMain.observe(i);
        }
      })
      
      this.targetContent.forEach((i) => {
        if (i) {
          this.observerContent.observe(i);
        }
      })
  
      this.targetSupport.forEach((i) => {
        if (i) {
          this.observerSupport.observe(i);
        }
      })
  
    }
  
    observerCallbackMain(entries, observerMain) {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
              entry.target.classList.remove('invisible');
            }else{
              entry.target.classList.add('invisible');
            }
        })
    }
  
    observerCallbackContent(entries, observerContent) {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
              entry.target.classList.remove('invisible');
            }else{
              entry.target.classList.add('invisible');
            }
        })
    }
  
    observerCallbackSupport(entries, observerSupport) {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
              entry.target.classList.remove('invisible');
            }else{
              entry.target.classList.add('invisible');
            }
        })
    }
  
  })
}
